



































import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import cloneDeep from "lodash/clone";
import { WizardConfiguration } from "@/models/wizardConfiguration";
import validationMixin from "@/components/mixins/validationMixin";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepDisplay",
  mixins: [wizardStepsMixin, validationMixin],
  data() {
    return {
      config: {
        deviceDisplayMode:
          this.wizardConfiguration?.deviceDisplayMode ??
          this.deviceConfiguration.deviceDisplayMode ??
          0,
      },
      displayModeOptions: [
        {
          text: this.$t("policiesFields.DeviceDisplayModeDefault") as string,
          value: 0,
        },
        {
          text: this.$t("policiesFields.DeviceDisplayModeActive") as string,
          value: 1,
        },
        {
          text: this.$t("policiesFields.DeviceDisplayModePassive") as string,
          value: 2,
        },
      ],
    };
  },
  components: {
    VaButton,
  },
  methods: {
    onFinish() {
      const res = this.wizardConfiguration
        ? cloneDeep(this.wizardConfiguration)
        : ({} as WizardConfiguration);
      res.deviceDisplayMode = this.config.deviceDisplayMode;
      this.$emit("onUpdateConfig", res);
      this.onNext();
    },
  },
});
